import * as React from "react";
import styled from "styled-components";
import OverlayDropdownButton from "components/common/OverlayDropdownButton";
import FilterConfiguration from "components/common/EntityFilters/FilterConfiguration";
const Container = styled.div`
  margin-left: 5px;
`;
const FilterDropdown = ({
  attribute,
  children = void 0,
  filterableAttributes,
  filterValueRenderers = void 0,
  onCreateFilter,
  activeFilters
}) => {
  const selectedAttribute = filterableAttributes.find(({ id }) => id === attribute);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    OverlayDropdownButton,
    {
      title: children,
      bsSize: "small",
      buttonTitle: "Create Filter",
      closeOnSelect: false,
      dropdownZIndex: 1050
    },
    ({ toggleDropdown }) => {
      const _onCreateFilter = (filter, closeDropdown = true) => {
        if (closeDropdown) {
          toggleDropdown();
        }
        onCreateFilter(attribute, { value: filter.value, title: filter.title });
      };
      return /* @__PURE__ */ React.createElement(
        FilterConfiguration,
        {
          onSubmit: _onCreateFilter,
          allActiveFilters: activeFilters,
          attribute: selectedAttribute,
          filterValueRenderer: filterValueRenderers == null ? void 0 : filterValueRenderers[attribute]
        }
      );
    }
  ));
};
export default FilterDropdown;
